import { OktaAuth } from '@okta/okta-auth-js';
import configs from '../../config.json';
import { pipe } from 'fp-ts/lib/function';
import { left, right, map as emap } from 'fp-ts/lib/Either';

// TODO investigate second signin
// const rediretOkta = () => {
//   window.location.href = `${import.meta.env.VITE_OKTA_CSOS_APP}/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${import.meta.env.VITE_OKTA_REDIRECT_URL}&state=111111`;
// };

const config = {
  clientId: `${import.meta.env.VITE_OKTA_CLIENT_ID}`,
  issuer: `${import.meta.env.VITE_OKTA_ORG_URL}/oauth2/default`,
  redirectUri: `${import.meta.env.VITE_OKTA_REDIRECT_URL}`,
  scopes: ['openid', 'profile', 'email'],
  pkce: false,
};

export const logoutOkta = async () => {
  // Will redirect to Okta to end the session then redirect back to the configured `postLogoutRedirectUri`
  const oktaAuth = new OktaAuth(config);
  oktaAuth.signOut().then(() =>
    pipe(
      configs.base,
      a => (a === undefined ? left(a) : right(a)),
      emap(a => (window.location.href = a))
    )
  );
};

// TODO investigate CORS error
// export const logoutOkta: (
//   idToken: string
// ) => Promise<Either<undefined, undefined>> = (idToken: string) =>
//   csosOktaApi()
//     .get(
//       `${import.meta.env.VITE_OKTA_CSOS_APP}/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${import.meta.env.VITE_OKTA_REDIRECT_URL}&state=111111`
//     )
//     .then(() => right(void 0))
//     .catch(() => left(void 0));
